"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocaleContext_1 = require("./LocaleContext");
Object.defineProperty(exports, "LocaleContext", { enumerable: true, get: function () { return LocaleContext_1.LocaleContext; } });
Object.defineProperty(exports, "useLocale", { enumerable: true, get: function () { return LocaleContext_1.useLocale; } });
//# sourceMappingURL=index.js.map